// Hands the signup email across the hard navigation to the verification page.
// sessionStorage rather than history state (survives the full page load) or the URL (no PII in logs).
const KEY = 'signup:email'

export function storeSignupEmail(email: string) {
  sessionStorage.setItem(KEY, email)
}

export function readSignupEmail(): string {
  return sessionStorage.getItem(KEY) ?? ''
}
